// Plugin PWA para registrar el killer service worker
export default {
  install(app) {
    // Registrar el killer service worker
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js')
        .then((registration) => {
          console.log('Killer SW registrado:', registration);
        })
        .catch((error) => {
          console.error('Error registrando killer SW:', error);
        });

      // Escuchar mensajes del service worker
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data && event.data.type === 'SW_CLEANUP') {
          console.log('Recibido mensaje de limpieza del SW, recargando página...');
          window.location.reload();
        }
      });
    }
  }
} 